// extracted by mini-css-extract-plugin
export default {"container__heading":"OpalRoleSuggestionInstanceEnablement_container__heading__sn9Ct"};